import LeaveTypeEditComponent from "../components/LeaveTypeEdit";
import useLeaveTypeEdit from "../hooks/useLeaveTypeEdit";

function LeaveTypeEdit() {
  const useLeaveTypeEditProps = useLeaveTypeEdit();
  return <LeaveTypeEditComponent {...useLeaveTypeEditProps} />;
}

export default LeaveTypeEdit;
